// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid--things[data-v-29e92424] {\n  display: grid;\n  grid-auto-flow: dense;\n  grid-template-columns: repeat(auto-fill, minmax(34rem, 1fr));\n  grid-template-rows: 7.5rem repeat(auto-fill, minmax(15rem, 1fr));\n  height: 100%;\n}\n.select-thing[data-v-29e92424] {\n  grid-column: 1/-1;\n}\n.live[data-v-29e92424] {\n  grid-area: span 1/span 1;\n}\n@media (min-width: 1200px) {\n.live[data-v-29e92424] {\n    grid-area: span 1/span 2;\n}\n}", ""]);
// Exports
module.exports = exports;
